import styled from "styled-components";

import { MenuContent as ADSMenuContent } from "../../Menu";

export const MenuContent = styled(ADSMenuContent)`
  width: 220px;
  max-height: unset;
`;

export const ButtonContainer = styled.div`
  position: relative;
`;
